export const fullName = (u) =>
  [u?.first_name, u?.last_name].filter(Boolean).join(" ") || u?.username || "—";

export const initials = (u) =>
  fullName(u)
    .split(" ")
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
